import { useState } from 'react';
import { toast } from 'react-toastify';
import { FaArrowRight, FaComments, FaWhatsapp } from 'react-icons/fa';
import { mensagemDeErro, onboardingService } from '../../services/onboarding';
import { rastrearTeste } from '../../services/rastreamentoTeste';
import { PARAMETRO_PRIORIDADES } from './ModalPrioridades';
import { Aviso, Botao, Rodape, Subtitulo, Titulo } from './styles';

const WHATSAPP_COMERCIAL = 'https://wa.me/5585991491356?text=' + encodeURIComponent('Olá! Acabei de configurar a minha locadora no teste do LocaSmartPro e quero falar sobre os planos.');

interface Props {
    aoFinalizar: (rota: string) => void;
}

// Encerra o onboarding e leva ao painel, que abre as prioridades escolhidas no começo.
export default function EtapaFinal({ aoFinalizar }: Props) {
    const [finalizando, setFinalizando] = useState(false);

    const irParaOPainel = async () => {
        setFinalizando(true);
        try {
            await onboardingService.concluir();
            rastrearTeste('onboarding_concluido');
            aoFinalizar(`/home?${PARAMETRO_PRIORIDADES}=true`);
        } catch (error) {
            toast.error(mensagemDeErro(error, 'Não foi possível concluir. Tente novamente.'));
            setFinalizando(false);
        }
    };

    return (
        <>
            <Titulo>Sua locadora está configurada</Titulo>
            <Subtitulo>Frota cadastrada e primeira locação criada. No painel, mostramos por onde começar com as prioridades que você escolheu.</Subtitulo>

            <Aviso style={{ alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                <span style={{ display: 'flex', gap: 10, alignItems: 'center' }}><FaComments /> Ficou com dúvida ou quer conhecer os planos? Fale com o nosso comercial.</span>
                <Botao as="a" href={WHATSAPP_COMERCIAL} target="_blank" rel="noopener noreferrer" $variante="secundario"
                    onClick={() => rastrearTeste('onboarding_whatsapp_comercial')}>
                    <FaWhatsapp /> Falar com o comercial
                </Botao>
            </Aviso>

            <Rodape>
                <span />
                <Botao type="button" disabled={finalizando} onClick={irParaOPainel}>Ir para o painel <FaArrowRight /></Botao>
            </Rodape>
        </>
    );
}
